export default __webpack_public_path__ + "static/media/KZ.T.15.2499.08cfd340.svg";